import React from 'react'
import Link from 'next/link'
import { t } from "@lingui/core/macro";

const Support = ({ context, caisses, mainLabel }) => {

    const { org } = context

    return (
        <div className="support-area section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="support-text">
                            <span>{t`Nous Soutenir`}</span>
                            <h2>{t`Nous avons besoin de vous`}</h2>
                            <p>{t`Joignez-vous à notre cause en soutenant nos actions du quotidien. Votre appui est essentiel pour la réussite de notre mission.`}</p>
                            <div className="btns">
                                <Link href={org.BASE_WEB_URL + "/don"}>
                                    <button className="theme-btn-s3">{mainLabel}</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="progress-area">
                            <div className="row">

                                {caisses.map((item, index) => {
                                    var displayTarget = item.objectif + item.marge
                                    var displayTotal = item.total + item.marge
                                    var showedObjectif = displayTarget

                                    if (item.smart) {
                                        displayTarget = item.objectif
                                        displayTotal = item.payed
                                        if (displayTotal < 0) {
                                            displayTotal = 0
                                        }
                                    }

                                    var percent = displayTotal * 100 / displayTarget

                                    let rightValue = (180 / 50) * percent
                                    let leftValue = 0

                                    if (percent >= 50) {
                                        rightValue = 180
                                        leftValue = (180 / 50) * (percent - 50)

                                    } else if (percent > 0) {
                                        rightValue = (180 / 50) * percent
                                    }

                                    return (
                                        <Link href={org.BASE_WEB_URL + "/don/" + item.id}>
                                            <div className="col-lg-4 col-sm-4 custom-grid" style={{ cursor: "pointer" }}>
                                                <div className="progress-wrap">
                                                    <div className={"progress s" + (index + 1)}>
                                                        <span className="progress-left">
                                                            <span className="progress-bar" style={{ transform: "rotate(" + leftValue + "deg)" }}></span>
                                                        </span>
                                                        <span className="progress-right">
                                                            <span className="progress-bar" style={{ transform: "rotate(" + rightValue + "deg)" }}></span>
                                                        </span>
                                                        <div className="progress-value">{Math.round(percent)}%</div>
                                                    </div>
                                                    <span>{item.name}</span>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Support;
